module.exports = __webpack_public_path__ + "static/img/Logo设计.53e48d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/Logo设计.png
// module id = ves1
// module chunks = 1